export interface IUser {
  _id?: string;
  employeeId: number;
  firstname: string;
  lastname: string;
  qrToken: string;
  role: UserRole;
  state: UserState;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum UserRole {
  ADMIN = 'ADMIN',
  FERTIGUNGSMITARBEITER = 'FERTIGUNGSMITARBEITER',
  BUERO = 'BUERO',
  WARENEINGANG = 'WARENEINGANG',
  ENDKONTROLLE = 'ENDKONTROLLE',
  WARENAUSGANG = 'WARENAUSGANG',
}

export enum UserState {
  DEACTIVATED = 'DEACTIVATED',
  ACTIVE = 'ACTIVE',
}
